<template>
	<view style="width: 100%;height: 100%;overflow: hidden;position: absolute;top: 0;left: 0;">
		<view style="display: block;width: 100%;height: 60rpx;padding-top: 86rpx;text-align: center;background-color: #fff;">
			<view style="position: absolute;left: 20rpx;top: 50rpx;z-index: 999;" @tap="back">
				<uni-icons type="back" size="60r" color="#000"></uni-icons>
			</view>
			<text style="font-size: 32rpx;position: relative;top: -12rpx;">VIN码识别结果</text>
		</view>
		<view>
			<text v-if="vin.length > 0" class="t1">请核查识别结果与图片数据是否一致</text>
			<view v-if="vin.length == 0 && testLock == 1">
				<text class="t1" style="display: inline;margin-left: 10%;">识别失败，您可以手动输入或</text><text style="color: #6096c7;margin-left: 5px;" @tap="toCamera">重新扫描</text>
			</view>
			<image v-if="isc == 1" :src="resImg" :style="resStyle"></image>
			<view v-if="isc == 0" :style="resStyle"></view>
			<view>
				<block v-for="(item, index) in char" :key="index">
					<input class="char" type="text" @focus="setVinInd(index)" @blur="setVin" :value="item" v-if="index == 0" style="margin-left: 20rpx;border-left: 1px solid rgba(0,0,0,.2);">
					<input class="char" type="text" @focus="setVinInd(index)" @blur="setVin" :value="item" v-else>
				</block>
			</view>
			<!-- <input type="text" :maxlength="vinLen" :focus="isFocus" @blur="nInp" @input="inputVin" style="width: 0;height: 0;"> -->
			<button class="serch" @tap="doSearch">确定</button>
		</view>
		<canvas canvas-id="vinImgCanvas" id="vinImgCanvas" style="width: 3000rpx;height: 3000rpx;opacity: 0;position: absolute;top: 100%;"></canvas>
		<image :src="vinImg" style="opacity: 0;" @load="setVinImg"></image>
	</view>
</template>

<script>
	const app = getApp();
	export default {
		onLoad(option) {
			this.isc = option.isc
			// #ifdef MP-WEIXIN
			this.vinImg = option.url
			// #endif
			
			// #ifdef H5
			if ('url' in option) {
				this.vinImg = option.url
			} else {
				this.vinImg = uni.getStorageSync('vin64');
			}
			// #endif
			if (this.isc == 0) {
				this.isAd = option.isad
				console.log(option)
				let data = JSON.parse(option.data)
				this.vin = data.vin
				this.char = data.char
				this.testLock = 1
			}
		},
		data() {
			return {
				testLock: 0,
				isAd: 1,
				wb: 0,
				nx: 0,
				ny: 0,
				sw: 0,
				sh: 0,
				ctx: {},
				resImg: '',
				resStyle: '',
				vinImg: '',
				vinImgWidth: '',
				vinImgHeigh: '',
				char: ['','','','','','','','','','','','','','','','',''],
				vin: '',
				isc: 1,
				writeInd: 0,
			}
		},
		methods: {
			setVinInd(index) {
				this.writeInd = index
			},
			setVin(e) {
				this.char[this.writeInd] = e.detail.value
				if (this.vin.length < 17) {
					this.vin = this.vin.substring(0,this.writeInd)+e.detail.value+this.vin.substring(this.writeInd)
				} else {
					this.vin = this.vin.substring(0,this.writeInd)+e.detail.value+this.vin.substring(this.writeInd+1)
				}
			},
			back() {
				if (this.isc == 0) {
					let urlBig = uni.getStorageSync('vinBig');
					console.log(urlBig)
					uni.redirectTo({url: '/pages/index/fetchData?isc=0&url='+urlBig});
				} else {
					uni.navigateBack()
				}
			},
			toCamera() {
				uni.redirectTo({url: '/pages/index/camera'});
			},
			doSearch() {
				if (this.vin) {
					uni.redirectTo({ url: '/pages/item/vinSearch?vin=' + this.vin });
				} else {
					uni.showToast({title:'请输入车架号',icon:'none'})
				}
			},
			inputVin(e) {
				let that = this; 
				if (e.detail.value.length <= this.vinLen) {
					that.char = e.detail.value.split('')
					if (that.char.length < this.vinLen) {
						let loopNum = this.vinLen - that.char.length
						for (let i = 0; i < loopNum; i++) {
							that.char.push('')
						}
					}
				}
			},
			nInp(e) {
				this.isFocus = false
			},
			img2base64(url,ext)
			{
				return 'data:image/jpeg;base64,'+uni.getFileSystemManager().readFileSync(url,'base64')
			},
			setVinImg(e) {
				let that = this
				uni.getSystemInfo({
					success:function(res){
						that.sw = res.screenWidth
						that.sh = res.screenHeight
					}
				})
				this.vinImgWidth = e.detail.width
				this.vinImgHeigh = e.detail.height
				this.wb = this.sw / this.vinImgWidth
				if (this.isAd == 0) {
					let height = this.wb * 0.96 * this.vinImgHeigh
					if (height > this.sh * 0.5) {
						height = this.sh * 0.5
						let wb2 = height / this.vinImgHeigh
						this.resStyle = 'width:'+this.sw * 0.96+'px;height:'+height+'px;margin-left:2%;background-image:url(\''+this.vinImg+'\');margin-bottom:20rpx;background-size: '+wb2*this.vinImgWidth+'px '+height+'px;background-repeat: no-repeat;background-position: center;'
					} else {
						this.resStyle = 'width:'+this.sw * 0.96+'px;height:'+height+'px;margin-left:2%;background-image:url(\''+this.vinImg+'\');margin-bottom:20rpx;'
					}
				} else {
					this.resStyle = 'width:'+this.sw * 0.96+'px;height:100px;margin-left:2%;'
				}
				if (this.isc == 0 && this.isAd == 1) {
					this.resStyle += 'background-image:url(\''+this.vinImg+'\');margin-bottom:20rpx;background-size: '+ this.sw * 0.96 +'px 100px;'
				}
				if (this.isc == 1) {
					console.log(this.wb)
					this.ctx = uni.createCanvasContext('vinImgCanvas', this)
					this.nx = this.sw * 0.02
					this.ny = this.sh * 0.28
					this.ctx.drawImage(this.vinImg,0,0,this.sw,this.vinImgHeigh * this.wb)
					this.ctx.draw()
					setTimeout(function() {
						uni.canvasToTempFilePath({
							x: that.nx,
							y: that.ny,
							width: that.sw * 0.96,
							height: 100,
							canvasId: 'vinImgCanvas',
							success: (res) => {
								that.resImg = res.tempFilePath
								let data = {img: that.img2base64(res.tempFilePath)}
								app.getApi('POST','data/vinOcr', data, 1, function(result){
									if (result.vin.length > 0) {
										that.vin = result.vin
										that.char = result.char
									}
									that.testLock = 1
								})
							}
						}, that)						
					},500)
				}
			}
		}
	}
</script>

<style>
	.char {
		border: 1px solid rgba(0,0,0,.2);
		width: 4.85%;
		padding: 20rpx 2rpx;
		text-align: center;
		font-size: 32rpx;
		float: left;
		border-radius: 0;
		border-left: 0px;
	}
	.t1 {
		display: block;
		line-height: 60rpx;
		color: #FF5722;
		text-align: center;
		margin-top: 15rpx;
		background-image: ;
	}
	.serch {
		background-color: #e7181e;
		color: #fff;
		width: 80%;
		height: 70rpx;
		line-height: 70rpx;
		position: relative;
		top: 30rpx;
	}
</style>
